import styled, { css } from 'styled-components';
import { darken } from 'polished';

interface LojaControlProps {
  lojaAberta: boolean;
}

interface IWhatsAppProps {
  whatsappState: boolean;
}

// const lojaAbertaColor = '#2196f3';
// const lojaFechadaColor = '#9e9e9e';
const lojaAbertaColor = 'rgba(215, 222, 233, 0.25)';
const lojaFechadaColor = 'rgba(215, 222, 233, 0.25)';

export const WarningButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    color: inherit;
  }
`;

export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    color: inherit;
  }
`;

export const LateralHeader = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  img {
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }

  span {
    font-weight: 500;
    font-size: 14px;
    color: #263238;
  }
`;

export const LojaControl = styled.button<LojaControlProps>`
  display: flex;
  align-items: center;

  font-size: 14px;
  background: ${lojaFechadaColor};
  color: #101d40;
  border: 1px solid ${darken(0.05, lojaFechadaColor)};
  border-radius: 5px;

  padding: 10px;
  transition: all 0.35s ease-in-out;

  &:hover {
    background: ${darken(0.05, lojaFechadaColor)};
    border-color: ${darken(0.1, lojaFechadaColor)};
  }

  ${(props) =>
    props.lojaAberta &&
    css`
      background: ${lojaAbertaColor};
      border-color: ${darken(0.05, lojaAbertaColor)};

      &:hover {
        background: ${darken(0.05, lojaAbertaColor)};
        border-color: ${darken(0.1, lojaAbertaColor)};
      }
    `}

  svg {
    margin-left: 5px;
  }
`;

export const ModalWrapper = styled.div`
  width: 320px;
  background: #fff;
  border-radius: 6px;
  padding: 10px 15px;

  div.header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 15px;

    > h1 {
      font-size: 20px;
      color: #212121;
    }

    > button {
      position: relative;
      background: transparent;
      border: none;
      color: #d32f2f;
      padding: 5px;
      border-radius: 15px;
      transition: all 0.35s ease-in-out;

      &:hover {
        color: #b71c1c;
        transform: scale(1.125);
      }
    }
  }

  div.description {
    margin-bottom: 20px;
    font-size: 16px;
    text-align: center;
  }

  div.btnActions {
    button {
      display: block;
      height: 35px;
      width: 100%;
      border-radius: 4px;

      margin-bottom: 7px;

      font-size: 14px;
      font-weight: 500;
      border: none;
      transition: all 0.35s ease-in-out;

      &.confirm {
        background: #1565c0;
        color: #fff;

        &:hover {
          background: #0d47a1;
        }

        &:disabled {
          border: 1px solid #757575;
          color: #757575;
          background: #f5f5f5 !important;
          cursor: not-allowed;
        }
      }

      &.cancel {
        border: 1px solid #1565c0;
        background: #fff;
        color: #1565c0;

        &:hover {
          color: #0d47a1;
          border: 1px solid #0d47a1;
        }
      }
    }
  }
`;

export const CompanyInfo = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 16px;
`;

export const DrawerBody = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  flex: 1;
  padding-top: 16px;
`;

export const WhatsAppBox = styled.div<IWhatsAppProps>`
  position: relative;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  margin-top: 50px;
  margin-bottom: 50px;
  width: 145px;
  border-radius: 5px;
  background-color: ${(props) => (props.whatsappState ? '#00BFA5' : '#F64444')};
  color: #fff;
`;

export const WhatsAppIconWrapper = styled.div<IWhatsAppProps>`
  position: absolute;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  top: -22.5px;
  background-color: #fbfbfb;
  color: ${(props) => (props.whatsappState ? '#00BFA5' : '#F64444')};
`;
